import {
  SET_FAVORITES_YACHTS, SET_IS_MORE_LICENSES, SET_IS_MORE_TEAM, SET_IS_MORE_YACHTS,
  SET_IYT_LICENSES,
  SET_LICENSES,
  SET_RESUME,
  SET_RESUME_CHARTERS,
  SET_RESUME_LICENSES,
  SET_SHARED_RESUME, SET_TEAM
} from "./profile-types";


export const setLicenses = (licenses) => ({type: SET_LICENSES, licenses})
export const setResume = (resume) => ({type: SET_RESUME, resume})
export const setResumeLicenses = (resumeLicenses) => ({type: SET_RESUME_LICENSES, resumeLicenses})
export const setResumeCharters = (resumeCharters) => ({type: SET_RESUME_CHARTERS, resumeCharters})
export const setIytLicenses = (iytLicenses) => ({type: SET_IYT_LICENSES, iytLicenses})
export const setSharedResume = (sharedResume) => ({type: SET_SHARED_RESUME, sharedResume})
export const setFavoriteYachts = (favoriteYachts) => ({type: SET_FAVORITES_YACHTS, favoriteYachts})
export const setTeam = (team) => ({type: SET_TEAM, team})

export const setIsMoreLicenses = (isMoreLicenses) => ({type: SET_IS_MORE_LICENSES, isMoreLicenses})
export const setIsMoreYachts = (isMoreYachts) => ({type: SET_IS_MORE_YACHTS, isMoreYachts})
export const setIsMoreTeam = (isMoreTeam) => ({type: SET_IS_MORE_TEAM, isMoreTeam})
